export const UnitOptions = {
  '': [{ name: 'None', value: 'none' }],

  // APM
  APM: [{ name: 'span', value: 'span' }],

  // 비트 Bits
  Bits: [
    { name: 'bit (b)', value: 'bit (b) - Bits' },
    { name: 'byte (B)', value: 'byte (B) - Bits' },
    { name: 'kilobit (kb)', value: 'kilobit (kb)' },
    { name: 'megabit (mb)', value: 'megabit (mb)' },
    { name: 'gigabit (gb)', value: 'gigabit (gb)' },
    { name: 'terabit (tb)', value: 'terabit (tb)' },
    { name: 'petabit (pb)', value: 'petabit (pb)' },
    { name: 'exabit (eb)', value: 'exabit (eb)' },
  ],

  // 바이트(바이너리) Bytes(binary)
  'Bytes(binary)': [
    { name: 'bit (b)', value: 'bit (b) - Bytes(binary)' },
    { name: 'byte (B)', value: 'byte (B) - Bytes(binary)' },
    { name: 'kibibyte (KiB)', value: 'kibibyte (KiB)' },
    { name: 'mebibyte (MiB)', value: 'mebibyte (MiB)' },
    { name: 'gibibyte (GiB)', value: 'gibibyte (GiB)' },
    { name: 'tebibyte (TiB)', value: 'tebibyte (TiB)' },
    { name: 'pebibyte (PiB)', value: 'pebibyte (PiB)' },
    { name: 'exbibyte (EiB)', value: 'exbibyte (EiB)' },
  ],

  // 바이트 Bytes(decimal)
  'Bytes(decimal)': [
    { name: 'bit (b)', value: 'bit (b) - Bytes(decimal)' },
    { name: 'byte (B)', value: 'byte (B) - Bytes(decimal)' },
    { name: 'kilobyte (KB)', value: 'kilobyte (KB)' },
    { name: 'megabyte (MB)', value: 'megabyte (MB)' },
    { name: 'gigabyte (GB)', value: 'gigabyte (GB)' },
    { name: 'terabyte (TB)', value: 'terabyte (TB)' },
    { name: 'petabyte (PB)', value: 'petabyte (PB)' },
    { name: 'exabyte (EB)', value: 'exabyte (EB)' },
  ],

  // 초당 비트 Bits/sec
  'Bits/sec': [
    { name: 'bit (b)/sec', value: 'bit (b)/sec - Bits/sec' },
    { name: 'byte (B)/sec', value: 'byte (B)/sec - Bits/sec' },
    { name: 'kilobit (kb)/sec', value: 'kilobit (kb)/sec' },
    { name: 'megabit (mb)/sec', value: 'megabit (mb)/sec' },
    { name: 'gigabit (gb)/sec', value: 'gigabit (gb)/sec' },
    { name: 'terabit (tb)/sec', value: 'terabit (tb)/sec' },
    { name: 'petabit (pb)/sec', value: 'petabit (pb)/sec' },
    { name: 'exabit (eb)/sec', value: 'exabit (eb)/sec' },
  ],

  // 초당 바이트(바이너리) Bytes(binary)
  'Bytes(binary)/sec': [
    { name: 'bit (b)/sec', value: 'bit (b)/sec - Bytes(binary)/sec' },
    { name: 'byte (B)/sec', value: 'byte (B)/sec - Bytes(binary)/sec' },
    { name: 'kibibyte (KiB)/sec', value: 'kibibyte (KiB)/sec' },
    { name: 'mebibyte (MiB)/sec', value: 'mebibyte (MiB)/sec' },
    { name: 'gibibyte (GiB)/sec', value: 'gibibyte (GiB)/sec' },
    { name: 'tebibyte (TiB)/sec', value: 'tebibyte (TiB)/sec' },
    { name: 'pebibyte (PiB)/sec', value: 'pebibyte (PiB)/sec' },
    { name: 'exbibyte (EiB)/sec', value: 'exbibyte (EiB)/sec' },
  ],

  // 캐시 Cache
  Cache: [
    { name: 'hit', value: 'hit' },
    { name: 'miss', value: 'miss' },
    { name: 'eviction', value: 'eviction' },
    { name: 'get', value: 'get' },
    { name: 'set', value: 'set' },
  ],

  // CPU
  CPU: [
    { name: 'nanocore (ncores)', value: 'nanocore (ncores)' },
    { name: 'microcore (μcores)', value: 'microcore (μcores)' },
    { name: 'millicore (mcores)', value: 'millicore (mcores)' },
    { name: 'core', value: 'core' },
    { name: 'kilocore (Kcores)', value: 'kilocore (Kcores)' },
    { name: 'megacore (Mcores)', value: 'megacore (Mcores)' },
    { name: 'gigacore (Gcores)', value: 'gigacore (Gcores)' },
    { name: 'teracore (Tcores)', value: 'teracore (Tcores)' },
    { name: 'petacore (Pcores)', value: 'petacore (Pcores)' },
    { name: 'exacore (Ecores)', value: 'exacore (Ecores)' },
  ],

  // 전류 Current
  Current: [
    { name: 'milliampere (mA)', value: 'milliampere (mA)' },
    { name: 'ampere (A)', value: 'ampere (A)' },
  ],

  // DB
  DB: [
    { name: 'table', value: 'table' },
    { name: 'index (idx)', value: 'index (idx)' },
    { name: 'lock', value: 'lock' },
    { name: 'transaction (tx)', value: 'transaction (tx)' },
    { name: 'query', value: 'query' },
    { name: 'row', value: 'row' },
    { name: 'key', value: 'key' },
    { name: 'command (cmd)', value: 'command (cmd)' },
    { name: 'offset', value: 'offset' },
    { name: 'record', value: 'record' },
    { name: 'object', value: 'object' },
    { name: 'cursor', value: 'cursor' },
    { name: 'assertion (assert)', value: 'assertion (assert)' },
    { name: 'scan', value: 'scan' },
    { name: 'document', value: 'document' },
    { name: 'shard', value: 'shard' },
    { name: 'flush', value: 'flush' },
    { name: 'merge', value: 'merge' },
    { name: 'refresh', value: 'refresh' },
    { name: 'fetch', value: 'fetch' },
    { name: 'column (col)', value: 'column (col)' },
    { name: 'commit', value: 'commit' },
    { name: 'wait', value: 'wait' },
    { name: 'ticket', value: 'ticket' },
    { name: 'question', value: 'question' },
    { name: 'collection', value: 'collection' },
    { name: 'entity', value: 'entity' },
    { name: 'vector', value: 'vector' },
  ],

  // 디스크 Disk
  Disk: [
    { name: 'file', value: 'file' },
    { name: 'inode', value: 'inode' },
    { name: 'sector', value: 'sector' },
    { name: 'block (blk)', value: 'block (blk)' },
    { name: 'volume', value: 'volume' },
  ],

  // 주파수 Frequency
  Frequency: [
    { name: 'hertz (Hz)', value: 'hertz (Hz)' },
    { name: 'kilohertz (kHz)', value: 'kilohertz (kHz)' },
    { name: 'megahertz (MHz)', value: 'megahertz (MHz)' },
    { name: 'gigahertz (GHz)', value: 'gigahertz (GHz)' },
  ],

  // 일반
  General: [
    { name: 'buffer (buff)', value: 'buffer (buff)' },
    { name: 'error (err)', value: 'error (err)' },
    { name: 'read (rd)', value: 'read (rd)' },
    { name: 'write (wr)', value: 'write (wr)' },
    { name: 'occurrence', value: 'occurrence' },
    { name: 'event', value: 'event' },
    { name: 'time', value: 'time' },
    { name: 'unit', value: 'unit' },
    { name: 'operation (op)', value: 'operation (op)' },
    { name: 'item', value: 'item' },
    { name: 'task', value: 'task' },
    { name: 'worker', value: 'worker' },
    { name: 'resource (res)', value: 'resource (res)' },
    { name: 'garbage collection (gc)', value: 'garbage collection (gc)' },
    { name: 'email', value: 'email' },
    { name: 'sample (smpl)', value: 'sample (smpl)' },
    { name: 'stage', value: 'stage' },
    { name: 'monitor', value: 'monitor' },
    { name: 'location', value: 'location' },
    { name: 'check', value: 'check' },
    { name: 'attempt', value: 'attempt' },
    { name: 'device (dev)', value: 'device (dev)' },
    { name: 'update (up)', value: 'update (up)' },
    { name: 'method (mthd)', value: 'method (mthd)' },
    { name: 'job', value: 'job' },
    { name: 'container', value: 'container' },
    { name: 'execution', value: 'execution' },
    { name: 'throttle', value: 'throttle' },
    { name: 'invocation', value: 'invocation' },
    { name: 'user', value: 'user' },
    { name: 'success', value: 'success' },
    { name: 'build', value: 'build' },
    { name: 'prediction', value: 'prediction' },
    { name: 'exception', value: 'exception' },
    { name: 'alert', value: 'alert' },
    // for api
    { name: 'topic', value: 'topic' },
    { name: 'consumer group', value: 'consumer group' },
    { name: 'count', value: 'count' },
    { name: 'state', value: 'state' },
    { name: 'minute (min) or terabyte (TiB)', value: 'minute (min) or terabyte (TiB)' },
    { name: 'stat', value: 'stat' },
    { name: 'credit', value: 'credit' },
    { name: 'number', value: 'number' },
    { name: 'count/sec', value: 'count/sec' },
    { name: 'count/second', value: 'count/second' },
    { name: 'num', value: 'num' },
    { name: 'topic partition', value: 'topic partition' },
    { name: 'lsn', value: 'lsn' },
    { name: 'bool', value: 'bool' },
    { name: 'credits', value: 'credits' },
    { name: 'count / minute (min)', value: 'count / minute (min)' },
    { name: 'age', value: 'age' },
    { name: 'count / 5 minute (min)', value: 'count / 5 minute (min)' },
    { name: 'vCPU-minutes', value: 'vCPU-minutes' },
    { name: 'sec/count', value: 'sec/count' },
    { name: 'string', value: 'string' },
  ],

  // 기록 Logging
  Logging: [{ name: 'entry', value: 'entry' }],

  // 메모리 Memory
  Memory: [
    { name: 'page (pg)', value: 'page (pg)' },
    { name: 'split', value: 'split' },
    { name: 'Heap', value: 'Heap' },
  ],

  Money: [
    { name: 'won (₩)', value: 'won (₩)' },
    { name: 'nanodollar (n$)', value: 'nanodollar (n$)' },
    { name: 'microdollar (μ$)', value: 'microdollar (μ$)' },
    { name: 'cent (¢)', value: 'cent (¢)' },
    { name: 'dollar ($)', value: 'dollar ($)' },
    { name: 'yen (¥)', value: 'yen (¥)' },
    { name: 'yuan (¥)', value: 'yuan (¥)' },
  ],

  // 네트워크 Network
  Network: [
    { name: 'connection (conn)', value: 'connection (conn)' },
    { name: 'request (req)', value: 'request (req)' },
    { name: 'packet (pkt)', value: 'packet (pkt)' },
    { name: 'segment (seg)', value: 'segment (seg)' },
    { name: 'response (rsp)', value: 'response (rsp)' },
    { name: 'message (msg)', value: 'message (msg)' },
    { name: 'payload', value: 'payload' },
    { name: 'timeout', value: 'timeout' },
    { name: 'datagram', value: 'datagram' },
    { name: 'route', value: 'route' },
    { name: 'session', value: 'session' },
    { name: 'hop', value: 'hop' },
  ],

  // 백분율 Percentage
  Percentage: [
    { name: 'percent nano (n%)', value: 'percent nano (n%)' },
    { name: 'percent (%)', value: 'percent (%)' },
    { name: 'apdex', value: 'apdex' },
    { name: 'fraction', value: 'fraction' },
  ],

  // 퍼텐셜 (Potential)
  Potential: [
    { name: 'millivolt (mV)', value: 'millivolt (mV)' },
    { name: 'volt (V)', value: 'volt (V)' },
  ],

  // 전력 (Power)
  Power: [
    { name: 'nanowatt (nW)', value: 'nanowatt (nW)' },
    { name: 'microwatt (μW)', value: 'microwatt (μW)' },
    { name: 'milliwatt (mW)', value: 'milliwatt (mW)' },
    { name: 'deciwatt (dW)', value: 'deciwatt (dW)' },
    { name: 'watt (W)', value: 'watt (W)' },
    { name: 'kilowatt (kW)', value: 'kilowatt (kW)' },
    { name: 'megawatt (MW)', value: 'megawatt (MW)' },
    { name: 'gigawatt (GW)', value: 'gigawatt (GW)' },
    { name: 'terawatt (TW)', value: 'terawatt (TW)' },
  ],

  // 신서틱 (Synthetic)
  Synthetic: [
    { name: 'run', value: 'run' },
    { name: 'step', value: 'step' },
  ],

  // 시스템 System
  System: [
    { name: 'process (proc)', value: 'process (proc)' },
    { name: 'thread', value: 'thread' },
    { name: 'host', value: 'host' },
    { name: 'node', value: 'node' },
    { name: 'fault', value: 'fault' },
    { name: 'service (svc)', value: 'service (svc)' },
    { name: 'instance', value: 'instance' },
    { name: 'cpu', value: 'cpu' },
  ],

  // 온도 Temperature
  Temperature: [
    { name: 'decidegree celsius (d°C)', value: 'decidegree celsius (d°C)' },
    { name: 'degree celsius (°C)', value: 'degree celsius (°C)' },
    { name: 'degree fahrenheit (°F)', value: 'degree fahrenheit (°F)' },
  ],

  // 시간 Time
  Time: [
    { name: 'nanosecond (ns)', value: 'nanosecond (ns)' },
    { name: 'microsecond (μs)', value: 'microsecond (μs)' },
    { name: 'millisecond (ms)', value: 'millisecond (ms)' },
    { name: 'centisecond (cs)', value: 'centisecond (cs)' },
    { name: 'second (s)', value: 'second (s)' },
    { name: 'minute (min)', value: 'minute (min)' },
    { name: 'hour (hr)', value: 'hour (hr)' },
    { name: 'day', value: 'day' },
    { name: 'week (wk)', value: 'week (wk)' },
    { name: 'month', value: 'month' },
    { name: 'year', value: 'year' },
  ],
} as const;

export const AllUnitOptions = Object.values(UnitOptions).flat();

export const AllUnitOptionValues = AllUnitOptions.map((item) => item.value);
export type AllUnitOptionValues = (typeof AllUnitOptionValues)[number];

export type UnitCategory = keyof typeof UnitOptions;

export const UnitCategoryByOption = Object.entries(UnitOptions).reduce((acc, [key, options]) => {
  options.forEach((option) => {
    acc[option.value] = key;
  });
  return acc;
}, {}) as Record<AllUnitOptionValues, UnitCategory>;

export const ApiUnitMap: Record<string, AllUnitOptionValues> = {
  // 바이트(바이너리) Bytes(binary)
  byte: 'byte (B) - Bytes(binary)',
  bytes: 'byte (B) - Bytes(binary)',
  kib: 'kibibyte (KiB)',
  KiB: 'kibibyte (KiB)',
  KB: 'kibibyte (KiB)',
  mb: 'mebibyte (MiB)',
  MB: 'mebibyte (MiB)',
  MiB: 'mebibyte (MiB)',
  gib: 'gibibyte (GiB)',
  GiB: 'gibibyte (GiB)',
  GB: 'gibibyte (GiB)',
  TiB: 'tebibyte (TiB)',
  TB: 'tebibyte (TiB)',
  PiB: 'pebibyte (PiB)',
  PB: 'pebibyte (PiB)',
  EiB: 'exbibyte (EiB)',
  EB: 'exbibyte (EiB)',

  // 초당 비트 Bits/sec
  bps: 'bit (b)/sec - Bits/sec',
  kbps: 'kilobit (kb)/sec',
  mbps: 'megabit (mb)/sec',
  gbps: 'gigabit (gb)/sec',
  tbps: 'terabit (tb)/sec',
  pbps: 'petabit (pb)/sec',
  ebps: 'exabit (eb)/sec',

  // 초당 바이트(바이너리) Bytes(binary)
  'bytes/sec': 'byte (B)/sec - Bytes(binary)/sec',
  'bytes/second': 'byte (B)/sec - Bytes(binary)/sec',
  'kilobytes/second': 'kibibyte (KiB)/sec',
  'kb/sec': 'kibibyte (KiB)/sec',
  'kib/sec': 'kibibyte (KiB)/sec',
  'KiB/sec': 'kibibyte (KiB)/sec',
  'KiB/second': 'kibibyte (KiB)/sec',
  'mib/sec': 'mebibyte (MiB)/sec',
  'mb/sec': 'mebibyte (MiB)/sec',
  'MiB/sec': 'mebibyte (MiB)/sec',
  'MiB/second': 'mebibyte (MiB)/sec',
  'gib/sec': 'gibibyte (GiB)/sec',
  'GiB/sec': 'gibibyte (GiB)/sec',
  'GiB/second': 'gibibyte (GiB)/sec',
  'tib/sec': 'tebibyte (TiB)/sec',
  'TiB/sec': 'tebibyte (TiB)/sec',
  'TiB/second': 'tebibyte (TiB)/sec',
  'pib/sec': 'pebibyte (PiB)/sec',
  'PiB/sec': 'pebibyte (PiB)/sec',
  'PiB/second': 'pebibyte (PiB)/sec',
  'eib/sec': 'exbibyte (EiB)/sec',
  'EiB/sec': 'exbibyte (EiB)/sec',
  'EiB/second': 'exbibyte (EiB)/sec',

  // CPU
  nanocore: 'nanocore (ncores)',
  microcore: 'microcore (μcores)',
  millicore: 'millicore (mcores)',
  milliCore: 'millicore (mcores)',
  core: 'core',
  Core: 'core',
  kilocore: 'kilocore (Kcores)',
  megacore: 'megacore (Mcores)',
  gigacore: 'gigacore (Gcores)',
  teracore: 'teracore (Tcores)',
  petacore: 'petacore (Pcores)',
  exacore: 'exacore (Ecores)',

  // 디스크 Disk
  block: 'block (blk)',
  blocks: 'block (blk)',

  // 주파수 Frequency
  MHz: 'megahertz (MHz)',

  // 일반
  topic: 'topic',
  'consumer group': 'consumer group',
  count: 'count',
  Count: 'count',
  State: 'state',
  state: 'state',
  time: 'time',
  table: 'table',
  'minutes or TBs': 'minute (min) or terabyte (TiB)',
  stat: 'stat',
  credit: 'credit',
  number: 'number',
  'count/sec': 'count/sec',
  'count/second': 'count/second',
  num: 'num',
  'topic partition': 'topic partition',
  lsn: 'lsn',
  bool: 'bool',
  none: 'none',
  credits: 'credits',
  'count/minute': 'count / minute (min)',
  age: 'age',
  'count/5min': 'count / 5 minute (min)',
  'vCPU-minutes': 'vCPU-minutes',
  'sec/count': 'sec/count',
  string: 'string',
  String: 'string',

  // 메모리 Memory
  pages: 'page (pg)',

  // 백분율 Percentage
  '%': 'percent (%)',

  // 전력 (Power)
  mW: 'milliwatt (mW)',

  // 온도 Temperature
  '°C': 'degree celsius (°C)',
  C: 'degree celsius (°C)',

  // 시간 Time
  µs: 'microsecond (μs)',
  usec: 'microsecond (μs)',
  ms: 'millisecond (ms)',
  cs: 'centisecond (cs)',
  s: 'second (s)',
  sec: 'second (s)',
  seconds: 'second (s)',
  m: 'minute (min)',
  minutes: 'minute (min)',
  h: 'hour (hr)',
  ns: 'nanosecond (ns)',
};
